export const ja = {
  sign_in: 'JA: Sign In'
}